import * as React from 'react'

import {ScrollDialog} from 'core/components/dialog/scroll-dialog'

interface IProps {
  onCloseJson?: () => void
  onOpenJson?: () => void
  showJson?: boolean
  json: any
}

export class RawJsonDialog extends React.PureComponent<IProps, {}> {
  public render() {
    return (
      <ScrollDialog
        actions={[{label: 'Exit', onClick: this.props.onCloseJson}]}
        active={this.props.showJson}
        onEscKeyDown={this.props.onCloseJson}
        onOverlayClick={this.props.onCloseJson}
        title='Prescription (raw)'
      >
        <pre>{JSON.stringify(this.props.json, null, 2)}</pre>
      </ScrollDialog>
    )
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/json/raw-json-dialog.tsx